<template>
    <div class="wrapper mx-auto">
        <img class='image mx-auto success-gif' src="@/assets/images/gifs/success.gif"/>
        <p class="bold-text is-size-4 mb-3">Thank you!</p>
        <p class="is-size-6-mobile is-size-5-tablet">You’ve successfully registered to receive Puls leads. When leads become available, we will send them via email to the email address that you registered with. You’ll have the opportunity to accept/decline. Please let us know if there are any questions</p>
		<button class="button is-primary my-6 bold-text is-fullwidth mx-auto" @click="done">{{ btnLabel }}</button>
    </div>
</template>
<script lang="ts">
import routes from "@/constants/routes";
import { emitterEvents } from "@/constants/utils";
import { LoginActions } from "@/store/modules/login/actions";
import { STATE_MODULES } from "@/store/state-modules";
import emitter from "@/utils/emitter";
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { JobsGetters } from "../../../store/modules/jobs/getters";

export default defineComponent({
	computed: {
		...mapGetters(STATE_MODULES.JOBS, {
			currentJob: JobsGetters.GET_CURRENT_JOB
		}),
		btnLabel () { 
			if (this.$route.path.startsWith(routes.PREFERENCES)) {
				return 'Go back to my preferences';
			} else if (this.currentJob) {
				return 'Close and claim job';
			}
			return 'Close'
		}
	},
	mounted () {
		this.$store.dispatch(`${STATE_MODULES.LOGIN}/${LoginActions.INIT_USER}`);
	},
	methods: {
		done () {
			emitter.emit(emitterEvents.DONE_TOP_UP, { claim: !!this.currentJob })
		}
	}
})
</script>

<style scoped>
    .wrapper {
        max-width: 700px !important;
    }

	.success-gif { 
		width: 220px;
		height: auto;
	}

	@media (max-width: 700px) {
		.success-gif {
			width: 150px;
		}
	}
</style>
